import script from "./Client.vue?vue&type=script&setup=true&lang=js"
export * from "./Client.vue?vue&type=script&setup=true&lang=js"

import "./Client.vue?vue&type=style&index=0&id=481d9473&lang=less"

const __exports__ = script;

export default __exports__